import React, { useState } from "react";
import { Grid, TextField, Typography, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Context from "../../../../context";
import {
  postContentGK,
  deleteData,
  updateContentGK,
} from "../../../../services";

const initContent = {
  id: "",
  no: "",
  company: "",
  link: "",
};

const CrudGK = ({ onCancel, action, title, data }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const context = React.useContext(Context);
  const [contentState, setContentState] = useState<any>({
    ...initContent,
    ...data,
  });
  const [loadingButtonState, setLoadingButtonState] = useState(false);

  const handleContentChange = (e: any) => {
    setContentState({
      ...contentState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const body = {
        id_type: data.id_type,
        company: contentState.company,
        link: contentState.link,
        no: contentState.no,
      };
      setLoadingButtonState(true);
      const res =
        action === "Edit"
          ? await updateContentGK(contentState.id, body)
          : await postContentGK(body);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar(`Berhasil merubah data ${contentState.titleId}`, {
        variant: "success",
      });
      onCancel();
      setContentState(initContent);
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  return (
    <>
      <Typography color="primary" variant="h4" style={{ marginBottom: "2rem" }}>
        {action} Data {title}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type="number"
            name="no"
            label="No."
            variant="outlined"
            value={contentState.no}
            onChange={handleContentChange}
            style={{ maxWidth: 200 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="company"
            label="Company"
            variant="outlined"
            value={contentState.company}
            onChange={handleContentChange}
            style={{ maxWidth: 400 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="link"
            label="Link"
            variant="outlined"
            value={contentState.link}
            onChange={handleContentChange}
            style={{ maxWidth: 400 }}
          />
        </Grid>
      </Grid>
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          marginTop: 32,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {action === "Edit" && (
          <Button
            variant="contained"
            onClick={() => {
              context.openDialog(
                "Hapus Data",
                `Apakah anda yakin ingin menghapus ${data.company} ?`,
                async () => {
                  try {
                    const res = await deleteData(data.id, {
                      tbl: "tbl_content_gk",
                    });
                    if (res.status === "error") {
                      enqueueSnackbar(res.message, {
                        variant: "error",
                      });
                      return;
                    }
                    context.closeDialog();
                    enqueueSnackbar(`Berhasil menghapus data ${data.titleId}`, {
                      variant: "success",
                    });
                    onCancel();
                    setContentState(initContent);
                  } catch (err: any) {
                    enqueueSnackbar(err.message, {
                      variant: "error",
                    });
                  }
                }
              );
            }}
            disabled={loadingButtonState}
          >
            Delete {title}
          </Button>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 16,
            flex: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              onCancel();
              setContentState(initContent);
            }}
            disabled={loadingButtonState}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loadingButtonState}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};

export default CrudGK;
